import { WordEntry } from "../types";

/**
 * 禁則文字を含まないひらがな単語・文データ
 * 禁則: 小文字(ゃゅょっぁぃぅぇぉゎ), 句読点(、。！？), 長音(ー), 空白, 英数字
 */
export const HIRAGANA_WORDS: WordEntry[] = [
  // === 2文字 word ===
  { text: "いま", type: "word" },
  { text: "そら", type: "word" },
  { text: "うみ", type: "word" },
  { text: "かぜ", type: "word" },
  { text: "はな", type: "word" },
  { text: "やま", type: "word" },
  { text: "つき", type: "word" },
  { text: "ほし", type: "word" },
  { text: "くも", type: "word" },
  { text: "あめ", type: "word" },
  { text: "ゆき", type: "word" },
  { text: "かわ", type: "word" },
  { text: "もり", type: "word" },
  { text: "いし", type: "word" },
  { text: "ひか", type: "word" },
  { text: "みず", type: "word" },
  { text: "いえ", type: "word" },
  { text: "まち", type: "word" },
  { text: "かみ", type: "word" },
  { text: "ひと", type: "word" },

  // === 3文字 word ===
  { text: "さくら", type: "word" },
  { text: "ひかり", type: "word" },
  { text: "こころ", type: "word" },
  { text: "あさひ", type: "word" },
  { text: "まつり", type: "word" },
  { text: "ゆめみ", type: "word" },
  { text: "みなと", type: "word" },
  { text: "すずめ", type: "word" },
  { text: "たから", type: "word" },
  { text: "きせつ", type: "word" },
  { text: "ふるさ", type: "word" },
  { text: "ことは", type: "word" },
  { text: "あかり", type: "word" },
  { text: "ひまわ", type: "word" },
  { text: "なみだ", type: "word" },
  { text: "たいこ", type: "word" },
  { text: "きつね", type: "word" },
  { text: "たぬき", type: "word" },
  { text: "うさぎ", type: "word" },
  { text: "かえる", type: "word" },

  // === 4文字 word ===
  { text: "あおぞら", type: "word" },
  { text: "ひだまり", type: "word" },
  { text: "いろはに", type: "word" },
  { text: "かたかな", type: "word" },
  { text: "さかなつ", type: "word" },
  { text: "あたらし", type: "word" },
  { text: "たのしみ", type: "word" },
  { text: "すばらし", type: "word" },
  { text: "ありがと", type: "word" },
  { text: "おはなし", type: "word" },
  { text: "かみなり", type: "word" },
  { text: "ふぶきの", type: "word" },
  { text: "にわとり", type: "word" },
  { text: "まなびや", type: "word" },
  { text: "ふくろう", type: "word" },
  { text: "かがみも", type: "word" },
  { text: "ほたるひ", type: "word" },
  { text: "けむりぐ", type: "word" },
  { text: "みのりの", type: "word" },
  { text: "はるかぜ", type: "word" },

  // === 5文字 word ===
  { text: "いただきま", type: "word" },
  { text: "おめでとう", type: "word" },
  { text: "おかえりな", type: "word" },
  { text: "いらしませ", type: "word" },
  { text: "しあわせな", type: "word" },
  { text: "やさしさの", type: "word" },
  { text: "あたたかい", type: "word" },
  { text: "すみません", type: "word" },
  { text: "がんばるぞ", type: "word" },
  { text: "おつかれさ", type: "word" },

  // === 6文字 word ===
  { text: "おはようござ", type: "word" },
  { text: "こんにちはと", type: "word" },
  { text: "ありがとうご", type: "word" },
  { text: "いただきます", type: "word" },
  { text: "おかえりなさ", type: "word" },
  { text: "おやすみなさ", type: "word" },
  { text: "はじめまして", type: "word" },
  { text: "よろしくおね", type: "word" },
  { text: "さようならと", type: "word" },
  { text: "ごめんなさい", type: "word" },

  // ==========================================================
  // S3〜S5: 同一文字の重複を意図的に配置
  // S1-S2では左→右の「リズム撃ち」で進める（学習フェーズ）
  // S3以降は重複文字により「どのインスタンスか」の判断が必要になる
  // 判定は pickedIndex===nextIndex（位置のみ）なので
  // 同じ文字の別位置をタップするとMissになる
  // ==========================================================

  // === 8〜10文字 sentence (S3: 同一文字の重複で位置判断を要求) ===
  // 8文字
  { text: "かぜがかぜをよぶ", type: "sentence" },   // か:0,3 ぜ:1,4
  { text: "はなはかぜにまう", type: "sentence" },   // は:0,2
  { text: "くもがくもをよぶ", type: "sentence" },   // く:0,3 も:1,4
  { text: "あきのあきをまつ", type: "sentence" },   // あ:0,3 き:1,4
  { text: "なみがなみをけす", type: "sentence" },   // な:0,3 み:1,4
  // 9文字
  { text: "そらにそらのいろが", type: "sentence" },  // そ:0,3 ら:1,4
  { text: "ほしがほしをみてる", type: "sentence" },  // ほ:0,3 し:1,4
  { text: "やまからやまへいく", type: "sentence" },  // や:0,4 ま:1,5
  { text: "あめのあとにあめが", type: "sentence" },  // あ:0,3,6 め:1,7
  { text: "つきがつきをてらす", type: "sentence" },  // つ:0,4 き:1,5
  // 10文字
  { text: "かがみにかおがうつる", type: "sentence" }, // か:0,4 が:1,6
  { text: "はなからはなへとんだ", type: "sentence" }, // は:0,4 な:1,5
  { text: "やまがやまをうみだす", type: "sentence" }, // や:0,3 ま:1,4
  { text: "あめがあめをよびだす", type: "sentence" }, // あ:0,3 め:1,4
  { text: "うみのうみがひろがる", type: "sentence" }, // う:0,3 み:1,4 が:5,8

  // === 11〜13文字 sentence (S4: 重複が3箇所以上、位置が離散) ===
  // 11文字
  { text: "あかいはなとあおいはな", type: "sentence" }, // あ:0,6 い:2,8 は:3,9 な:4,10
  { text: "はるのかぜがここちいい", type: "sentence" }, // こ:6,7 い:9,10
  { text: "つきのひかりがきれいだ", type: "sentence" }, // き:1,7
  // 12文字
  { text: "そらのいろがそらにうつる", type: "sentence" }, // そ:0,6 ら:1,7
  { text: "はるのかぜがはるをはこぶ", type: "sentence" }, // は:0,6,9 る:1,7
  { text: "かわのみずがかわをながれ", type: "sentence" }, // か:0,6 わ:1,7 が:5,10
  { text: "つきがのぼりつきがてらす", type: "sentence" }, // つ:0,6 き:1,7 が:2,8
  { text: "ゆめのなかのゆめがさめる", type: "sentence" }, // ゆ:0,6 め:1,7,10 の:2,5
  { text: "ひかりがひかりをうみだす", type: "sentence" }, // ひ:0,4 か:1,5 り:2,6
  // 13文字
  { text: "あたらしいあさがあたらしい", type: "sentence" }, // あ:0,5,8 た:1,9 ら:2,10 し:3,11 い:4,12
  { text: "さくらのはながさくらいろに", type: "sentence" }, // さ:0,7 く:1,8 ら:2,9
  { text: "あのやまのうえからあのうみ", type: "sentence" }, // あ:0,9 の:1,4,10 う:5,11

  // === 14〜15文字 sentence (S5: 重複が4箇所以上、リズム撃ち完全破綻) ===
  // 14文字
  { text: "あおいそらとあおいうみがみえ", type: "sentence" }, // あ:0,6 お:1,7 い:2,8 み:10,12
  { text: "はるのかぜとはるのはながまう", type: "sentence" }, // は:0,6,9 る:1,7 の:2,8
  { text: "はるのさくらがさくのをまつよ", type: "sentence" }, // さ:3,7 く:4,8 の:2,9
  { text: "なつのうみでおよぐのがすきだ", type: "sentence" }, // の:2,9
  { text: "ふゆのゆきがまちをしろくする", type: "sentence" }, // ゆ:1,3 く:11
  { text: "かぜのなかのかぜがかおをなで", type: "sentence" }, // か:0,4,6,9 ぜ:1,7 の:2,5 な:3,12
  // 15文字
  { text: "よるのほしがきらきらひかるよね", type: "sentence" }, // よ:0,14 る:1,13 き:6,8 ら:7,9
  { text: "ひかりがさすあさはきもちいいね", type: "sentence" }, // さ:4,7 い:12,13
  { text: "ふるさとのまつりがなつかしいな", type: "sentence" }, // な:9,14 つ:6,10
  { text: "あのひのあのそらをまたみたいな", type: "sentence" }, // あ:0,4 の:1,3,5 た:10,12
  { text: "ゆめのなかでゆめをみるゆめがあ", type: "sentence" }, // ゆ:0,6,11 め:1,7,12
  { text: "いまのいまをいきるのがたのしい", type: "sentence" }, // い:0,3,6,14 ま:1,4 の:2,9,12
];
